import React from 'react';

import { Badge } from '../../ui/badge';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../../lib/utils';

const EntityCard = ({ entity, documentsCount, onSelect, isSelected }) => {
  const Icon = entity.icon;
  return (
    <div 
      className={cn(
        "cursor-pointer transition-all duration-200 rounded-lg border-l-[5px] p-3",
        "hover:shadow-md",
        isSelected 
          ? `border-l-current ${entity.badgeColor.replace('bg-', 'border-l-')} bg-white shadow-md ring-1 ring-gray-200` 
          : "border-l-gray-200 bg-white hover:border-l-gray-400"
      )}
      onClick={() => onSelect(entity.id)}
      data-testid={`entity-card-${entity.id}`}
    >
      <div className="flex items-center gap-3">
        <div className={cn("w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0", entity.badgeColor)}>
          <Icon className="w-4 h-4 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-sm text-gray-900">{entity.name}</span>
            <Badge className={cn("text-[10px] text-white px-1.5 py-0", entity.badgeColor)}>
              {documentsCount || 0}
            </Badge>
          </div>
          <p className="text-xs text-gray-500 truncate">{entity.description}</p>
        </div>
        <ChevronRight className={cn("w-4 h-4 text-gray-400 transition-transform flex-shrink-0", isSelected && "rotate-90")} />
      </div>
    </div>
  );
};

// === DOCUMENT ROW (List View) ===

export default EntityCard;
